<template>
	<tr class="subject-data-row">
		<td style="height: 80px">
			<template v-if="image">
				<v-chip color="primary" v-if="matchingSubject">Merging with existing</v-chip>
				<template v-for="href in imageSrcSet">
					<v-img :height="80" :width="80" :src="href"  class="preview" @click="openPreview(href)" v-if="href" :key="href" />
					<v-chip color="red" dark :key="href" v-else>MISSING</v-chip>
				</template>
			</template>
			<v-chip color="primary" v-else-if="matchingSubject">Merging with existing</v-chip>
			<v-chip color="red" dark v-else>MISSING</v-chip>
		</td>
		<td v-for="(column, columnIndex) in row" :key="columnIndex" :style="columnStyle(columnIndex)">
			<v-tooltip v-if="false">

			</v-tooltip>
			<v-tooltip top v-if="getColumnMatch(columnIndex)">
				<template v-slot:activator="{ on, attrs }">
					<span v-bind="attrs" v-on="on">{{ columnDisplay(columnIndex) }}</span>
				</template>
				<span>Changed from "{{ getColumnMatch(columnIndex).before }}"</span>
			</v-tooltip>
			<span v-else>{{ columnDisplay(columnIndex) }}</span>
		</td>
	</tr>
</template>

<script>
import simpleAltFilename from './utils/simple-alt-name';
import simpleFilename from './utils/simple-filename';

export default {
	props: ['row', 'imageMap', 'altImageMap', 'imageFileColumn', 'matchingRows', 'matchingSubject', 'subjectFieldHeaders'],
	computed: {
		imageSrcSet() {
			if(this.image) {
				return [
					this.getImageSrc(this.row),
					...this.matchingRows.map((row) => {
						return this.getImageSrc(row);
					})
				];
			} else {
				return [];
			}
		},
		image() {
			return this.getImage(this.row);
		}
	},
	methods: {
		columnDisplay(columnIndex) {
			if(this.matchingRows.length > 0) {
				return [
					this.row[columnIndex],
					...this.matchingRows.map((row) => {
						return row[columnIndex];
					})
				].filter((value, index, self) => {
					return self.indexOf(value) === index;
				}).join(', ');
			} else {
				return this.row[columnIndex];
			}
		},
		columnStyle(columnIndex) {
			let columnMatch = this.getColumnMatch(columnIndex);
			if(columnMatch) {
				return {
					'font-weight': 'bold'
				};
			} else {
				return {};
			}
		},
		getColumnMatch(columnIndex) {
			if(this.matchingSubject && this.subjectFieldHeaders[columnIndex]) {
				let header = this.subjectFieldHeaders[columnIndex].field_key ?? this.subjectFieldHeaders[columnIndex].effective_label;
				if(this.row[columnIndex] != this.matchingSubject[header]) {
					return {
						before: this.matchingSubject[header],
						after: this.row[columnIndex]
					};
				} else {
					return null;
				}
			} else {
				return null;
			}
		},
		openPreview(href) {
			$.fancybox.open([{
					href: href,
					title: this.row[this.imageFileColumn]
				}], {
				padding : 0,
				type: 'image'
			});
		},
		getImage(row) {
			return this.imageMap[simpleFilename(row[this.imageFileColumn])] || this.altImageMap[simpleAltFilename(row[this.imageFileColumn])] || null;
		},
		getImageSrc(row) {
			let upload = this.getImage(row);
			if(upload) {
				if(upload.file.viewUrl) {
					return upload.file.viewUrl;
				} else {
					return URL.createObjectURL(upload.file);
				}
			} else {
				return null;
			}
		}
	}
};
</script>

<style scoped>
	tr.subject-data-row:nth-of-type(even), thead tr {
		background-color: rgba(0, 0, 0, .03);
	}
	
	.preview {
		cursor: pointer;
	}
</style>